import { inject, Injectable } from "@angular/core";

import type { FilterValue, BaseFilterDefinition } from "@filter/filter.types";
import type { IBaseT1Card } from "@app/views-interfaces";
import { isiFirmTaxDashboard, type TranslateObject } from "@app/views-interfaces";
import { DashboardsService } from "@shared/dashboards-service";
import { DeliveryMethodsService } from "@shared/delivery-methods-service";
import { IFirmDeliveryMethodsService } from "@shared/ifirm-delivery-methods";
import { SimpleFilterMulti } from "./types/simple-filter-multi";

@Injectable()
export class DeliveryMethodFilterService extends SimpleFilterMulti<IBaseT1Card> {
    private readonly dashboardsService = inject(DashboardsService);
    private readonly deliveryMethodsService = inject(DeliveryMethodsService);
    private readonly iFirmDeliveryMethodsService = inject(IFirmDeliveryMethodsService);

    protected getDefinitionInfo(): BaseFilterDefinition {
        return {
            filterName: "DeliveryMethod",
            label: "AllView.DeliveryMethod",
        };
    }

    protected getValue(item: IBaseT1Card): FilterValue | undefined {
        return item.deliveryMethod;
    }

    protected getLabel(value: FilterValue): string | undefined | null | TranslateObject {
        const dashboard = this.dashboardsService.currentDashboard();
        if (!dashboard) return;

        if (this.usesIFirmDeliveryMethods()) {
            return this.iFirmDeliveryMethodsService.currentDeliveryMethods()?.find((item) => item.Id === value);
        }

        return this.deliveryMethodsService.currentDeliveryMethods()[String(value)];
    }

    protected getAllValues(): readonly FilterValue[] {
        const dashboard = this.dashboardsService.currentDashboard();
        if (!dashboard) return [];

        if (this.usesIFirmDeliveryMethods()) {
            return this.iFirmDeliveryMethodsService.currentDeliveryMethods()?.map((method) => method.Id) ?? [];
        }

        return Object.keys(this.deliveryMethodsService.currentDeliveryMethods());
    }

    private usesIFirmDeliveryMethods(): boolean {
        const dashboard = this.dashboardsService.currentDashboard();
        return isiFirmTaxDashboard(dashboard) && (dashboard?.TaxYear ?? 0) >= 2025;
    }
}
